import axios from 'axios'
import moment from 'moment'
import _ from 'lodash'

export const FETCH_RESTAURANT_AVAILABILITY_BEGIN   = 'FETCH_RESTAURANT_AVAILABILITY_BEGIN'
export const FETCH_RESTAURANT_AVAILABILITY_SUCCESS = 'FETCH_RESTAURANT_AVAILABILITY_SUCCESS'
export const FETCH_RESTAURANT_AVAILABILITY_FAILURE = 'FETCH_RESTAURANT_AVAILABILITY_FAILURE'
export const RESET_RESTAURANT_AVAILABILITY = 'RESET_RESTAURANT_AVAILABILITY'

export const fetchRestaurantAvailabilityBegin = venueID => ({
	type: FETCH_RESTAURANT_AVAILABILITY_BEGIN,
	payload: venueID
})

export const fetchRestaurantAvailabilitySuccess = availableTimes => ({
	type: FETCH_RESTAURANT_AVAILABILITY_SUCCESS,
	payload: availableTimes
})

export const fetchRestaurantAvailabilityError = error => ({
	type: FETCH_RESTAURANT_AVAILABILITY_FAILURE,
	payload: error
})

export const resetRestaurantAvailability = venueId => dispatch => {
	dispatch({
		type: RESET_RESTAURANT_AVAILABILITY,
		payload: venueId
	})
}

// Handle Availability Fetch & Functionality
export default function fetchRestaurantAvailability(venueId, reservationDate, reservationStartTime, party) {
	return (dispatch) => {
		// Client ID key used by IPS to pull correct brand data
		let currentClientId = null

		if (
			process.env.REACT_APP_FLOW_CLIENT_ID &&
			process.env.REACT_APP_FLOW_CLIENT_ID !== 'null'
		) {
			currentClientId = process.env.REACT_APP_FLOW_CLIENT_ID
		}

		let endTime = '23:45'

		if (process.env.REACT_APP_COMPONENT_RESTAURANT_OPTIONS_END_TIME) {
			endTime = process.env.REACT_APP_COMPONENT_RESTAURANT_OPTIONS_END_TIME
		}

		// URL Params
		let urlParams = {
			date: moment(reservationDate, 'YYYY-MM-DD').format('YYYY-MM-DD'),
			startTime: reservationStartTime,
			endTime: endTime,
			partySize: party,
			clientId: currentClientId
		}

		// Fetch Query string method
		const fetchQuery = new URLSearchParams()

		// Loop urlParams for undefined values & remove
		for (let key in urlParams) {
			if (typeof urlParams[key] === "undefined") continue
			fetchQuery.append(key, urlParams[key])
		}

		// Base API path
		const reservationsApi = 'https://sbe.dolli.cloud/api/restaurant/venues/' + venueId + '?'

		// Combine API URL & formatted urlParams
		const reservationsEndpoint = reservationsApi + fetchQuery.toString()

		dispatch(fetchRestaurantAvailabilityBegin(venueId))
		return axios.get(reservationsEndpoint)
			.then((response) => {
				if (
					!_.isEmpty(response.data) &&
					response.data.data[0]
				) {
					const currentRestaurant = response.data.data[0]
					let restaurantData = {}

					// Key data to venue ID
					restaurantData[venueId] = {
						id: venueId,
						name: currentRestaurant.name,
						isClosed: currentRestaurant.is_closed,
						times: currentRestaurant.times
					}

					dispatch(fetchRestaurantAvailabilitySuccess(restaurantData, venueId))
				} else {
					throw new Error()
				}
			})
			.catch(error => {
				dispatch(fetchRestaurantAvailabilityError(venueId))
			})
	}
}


// WEBPACK FOOTER //
// ./src/actions/fetchRestaurantAvailability.js